import styled from 'styled-components';
import { Modal } from 'react-bootstrap';


export const StyledModal = styled(Modal)`
  /* Modal styles here */
  ${'' /* width: ${({ width }) => width || '400px'} ;
  height: ${({ height }) => height}; */}
  .modal-dialog {
    top:8%;
  }
  .modal-content{
    width: ${({ width }) => width || '400px'} ;
    height: ${({ height }) => height};
    padding :${({ padding }) => padding || '16px'};
    border-radius:12px;
  }
  .modal-body{
    padding:0px;
  }
  .modal-content-padding {
  ${'' /* width: ${({ width }) => width || '400px'} ; */}
  ${'' /* height: ${({ height }) => height}; */}
  ${'' /* padding: 16px;  */}
  ${'' /* padding :${({ padding }) => padding || '16px'}; */}
  ${'' /* top:70px; */}
}
`;

export const CalendarHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center; 
  justify-content: space-between;
  background: none;
  margin-bottom: 20px; 
  color: #184A61;
  font-family: 'Lato';
  font-size: 18px;
  font-weight: 700;

  .left-content {
    display: flex;
    align-items: center; 
    ${'' /* gap: 10px; */}

    .icon{
      display:flex;
      margin-right:12px;
    }
  }

  .close-icon {
    cursor: pointer;
    text-align: right;
  }
`;


export const Border = styled.div`
border:${({isBorder}) => isBorder ? isBorder : '1px solid #EFEFEF'};
 ${'' /* border: 1px solid #EFEFEF; */}
`;

export const CalendarWrapper = styled.div`
  ${'' /* padding: 25px; */}
  .second-text{
  margin-top:16px;
  margin-bottom:20px;
  color:  #CE7841;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  display:flex;
  justify-content:center;
  }
`;

export const ConfirmVisitText = styled.div`
  font-family: "Lato";
  font-size: 16px;
  color:${({isColor}) => isColor ? isColor : '#184A61'};
  text-align: center;
  margin: ${({margin}) => margin ? margin : '20px 0'};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content:center;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const Button = styled.button`
  min-width:${({isWidth}) => isWidth ? isWidth : '352px'};
  height:${({isHeight}) => isHeight ? isHeight : '48px'};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato';
  padding: 12px 16px;
  ${'' /* font-size: 18px; */}
  font-size:${({isFont}) => isFont ? isFont : '18px'};
  border: ${({ border }) => (border ? "1px solid #007AB1" : "none")};
  background: ${({ background }) => background || "#007AB1"};
  color: ${({ color }) => color || "#fff"};
  cursor: pointer;
  border-radius: 6px;
  :hover {
    background: ${({ backgroundHover }) => backgroundHover || ""};
    color: ${({ colorHover }) => colorHover || ""};
  }

  .btn-text{
    margin-left:8px;
  }
`;
